var React = require('react');

function Show (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 18.934 9.168 C 12.571 9.168 7.137 13.125 4.934 18.714 C 7.137 24.3 12.571 28.259 18.934 28.259 C 25.297 28.259 30.731 24.3 32.934 18.714 C 30.731 13.125 25.297 9.168 18.934 9.168 Z M 18.934 25.077 C 15.422 25.077 12.571 22.225 12.571 18.714 C 12.571 15.2 15.422 12.351 18.934 12.351 C 22.446 12.351 25.297 15.2 25.297 18.714 C 25.297 22.225 22.446 25.077 18.934 25.077 Z M 18.934 14.896 C 16.822 14.896 15.117 16.6 15.117 18.714 C 15.117 20.825 16.822 22.531 18.934 22.531 C 21.046 22.531 22.751 20.825 22.751 18.714 C 22.751 16.6 21.046 14.896 18.934 14.896 Z","fill":"#858585"}));
}

Show.defaultProps = {"width":"39","height":"39","viewBox":"0 0 39 39","fill":"none"};

module.exports = Show;

Show.default = Show;
